import { useNavigate } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import {
  AddCircleIcon,
  HandHeartIcon,
  Header,
  RestartCircleIcon,
} from "@/shared/ui";

interface ScheduleJourneySupportHeaderProps {
  isReschedule?: boolean;
}

export const ScheduleJourneySupportHeader = ({
  isReschedule,
}: ScheduleJourneySupportHeaderProps) => {
  const navigate = useNavigate();

  return (
    <Header.Root variant="secondary">
      <Header.Content>
        <Header.Breadcrumb
          links={[
            {
              href: ROUTES.COACHING.OVERVIEW,
              icon: HandHeartIcon,
              label: t`Coaching hub`,
            },
            {
              href: ROUTES.COACHING.JOURNEY_SUPPORT_SCHEDULE,
              icon: isReschedule ? RestartCircleIcon : AddCircleIcon,
              label: isReschedule
                ? t`Reschedule consultation`
                : t`Journey support consultation`,
            },
          ]}
        />

        <div className="flex gap-2">
          <Header.GoBackButton
            onClick={() => navigate(ROUTES.COACHING.OVERVIEW)}
            className="mt-3.5 md:hidden"
          />
          <Header.Title>
            {isReschedule ? t`Reschedule appointment` : t`New consultation`}
          </Header.Title>
        </div>
      </Header.Content>
    </Header.Root>
  );
};
